import { render, staticRenderFns } from "./service-card.vue?vue&type=template&id=75415d46&scoped=true&"
import script from "./service-card.vue?vue&type=script&lang=js&"
export * from "./service-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75415d46",
  null
  
)

export default component.exports